export const IS_ADMIN = 'IsAdmin'
export const IS_RESOURCE = 'IsResource'
export const IS_USER = 'IsUser'
export const IS_MENTOR = 'IsMentor'
export const SSO_LOGIN = 'SSO_LOGIN'
export const ADMIN_LOGIN = 'ADMIN_LOGIN'
export const TEXT_AREA_PLACEHOLDER = 'Only 1000 characters allowed'
